import { useEffect } from "react";
import { connect } from "react-redux";
import { verifyToken } from "../../../redux/auth/action";
import { useParams } from "react-router-dom";

interface PasswordResetJwtVerifyProps {
  verifyTokenReceived: (jwtToken: string, password: string | null, companyId: string) => void;
  computedMatch: {
    path: string;
    url: string;
    isExact: boolean;
    params: {
      jwt: string;
    };
  };
  company: {
    id: string;
    name: string;
    code: string;
    url: string;
  };
}

function PasswordResetJwtVerify({
  verifyTokenReceived,
  computedMatch,
  company,
}: PasswordResetJwtVerifyProps) {

  const { jwt } = computedMatch?.params ?? useParams()

  useEffect(() => {
    // 1) Guard against “undefined” on first render
    if (!jwt || !company?.id) {
      return;
    }

    // 2) Call the verifyTokenReceived exactly once (per change of jwt/company.id)
    verifyTokenReceived(jwt, null, company.id);
  }, [jwt, company?.id, verifyTokenReceived]);

  // This component doesn’t render anything itself.
  return null;
}

const mapStateToProps = (state) => ({
  company: state.company.company,
});
const matchDispatchToProps = (dispatch) => ({
  verifyTokenReceived: (jwtToken, password, companyId) =>
    dispatch(verifyToken(jwtToken, password, companyId)),
});

export default connect(mapStateToProps, matchDispatchToProps)(PasswordResetJwtVerify);
